<template>
    <ContentLoader v-slot :loading="playlist == null" class="h-screen-header flex flex-col">
        <div ref="heroContainer" class="flex-none rounded-xl transition-all duration-300 ease-out"
             :class="{'hero-minimized': isHeroMinimized}">
            <Hero :image="playlist.image" :is-minimized="isHeroMinimized">
                <!-- 普通状态的内容 -->
                <div v-if="!isHeroMinimized" class="flex flex-col md:justify-between h-16 md:h-56" 
                     style="transition: opacity 0.3s ease-out">
                    <div class="ml-4 flex flex-col justify-start items-start z-[9]">
                        <div class="flex items-center justify-center ml-1">
                            <div class="text-4xl font-medium text-clip overflow-hidden h-10 mb-2 md:mb-0">{{ playlist.name }}</div>
                        </div>
                        <div class="flex flex-col my-2 text-gray-600 !hidden md:!block">
                            <span>播放列表 {{ playlist.tracks.length }} 首歌曲</span>
                            <span>由{{ playlist.owner }} 创建于{{ formatDate(playlist.createdAt) }}</span>
                        </div>
                        <div v-if="playlist.comment" class="mb-3 text-gray-600 text-ellipsis overflow-hidden h-12 !hidden md:!block">
                            {{ playlist.comment }}
                        </div>
                        <div class="badge badge-neutral !hidden md:!block" v-if="playlist.isDynamic">
                            动态歌单
                        </div>
                        <div class="badge badge-neutral !hidden md:!block" v-if="playlist.privacyLevel === 'exclude'">
                            过滤歌单
                        </div>
                    </div>
                    <div class="ml-4 z-[9] flex">
                        <button class="btn btn-neutral btn-active btn-sm" @click="playNow(playlist.id)">
                            Play
                        </button>
                        <div class="drawer drawer-end w-16 ml-2">
                            <input id="my-drawer-4" type="checkbox" class="drawer-toggle" />
                            <div class="drawer-content">
                                <!-- Page content here -->
                                <label for="my-drawer-4" class="btn btn-neutral btn-active btn-sm"
                                    @click="handleEdit">EDIT</label>
                            </div>
                            <div class="drawer-side">
                                <label for="my-drawer-4" aria-label="close sidebar" class="drawer-overlay"></label>
                                <div class="p-4 w-80 min-h-full bg-base-200 text-base-content">
                                    <div class="font-medium text-xl mb-4">编辑播放列表信息</div>

                                    <div class="mb-1">名称:</div>
                                    <div>
                                        <input type="text" v-model="FormData.name"
                                            class="input input-bordered input-sm w-full max-w-xs" />
                                    </div>
                                    <div class="mb-1 mt-1">封面:</div>
                                    <div>
                                        <div style="display: flex;flex-direction: column;" v-if="reloadImg">
                                            <!-- 图片上传 -->
                                            <div class="relative">
                                                <!-- 图片预览区域 -->
                                                <div
                                                    class="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center hover:border-gray-400 transition-colors">
                                                    <div v-if="albumImagePreview" class="relative inline-block">
                                                        <img :src="albumImagePreview" alt="专辑封面"
                                                            class="max-w-full max-h-48 rounded-lg shadow-md">
                                                        <button @click.stop="removeAlbumImage"
                                                            class="absolute -top-2 -right-2 btn btn-circle btn-xs btn-error text-white hover:bg-red-600 z-50"
                                                            type="button" style="pointer-events: auto;">
                                                            ✕
                                                        </button>
                                                        <!-- 替换图片按钮 -->
                                                        <button @click.stop="triggerAlbumImageReplacement"
                                                            class="absolute -bottom-2 -right-2 btn btn-circle btn-xs btn-neutral text-white z-50"
                                                            type="button" style="pointer-events: auto;" title="替换图片">
                                                            +
                                                        </button>
                                                    </div>
                                                    <div v-else>
                                                        <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                                                            fill="none" viewBox="0 0 48 48">
                                                            <path
                                                                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                                                stroke-width="2" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                        <p class="mt-2 text-sm text-gray-500">点击上传或拖拽图片到此处</p>
                                                        <p class="text-xs text-gray-400">支持 JPG, PNG, GIF (最大 5MB)</p>
                                                    </div>

                                                    <!-- 隐藏的文件输入 -->
                                                    <input ref="albumImageInput" type="file" accept="image/*"
                                                        @change="handleAlbumImageChange"
                                                        class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                                        :disabled="isUploadingAlbumImage" v-show="!albumImagePreview">
                                                    <!-- 上传进度 -->
                                                    <div v-if="isUploadingAlbumImage"
                                                        class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center rounded-lg">
                                                        <div class="text-center">
                                                            <span class="loading loading-spinner loading-md"></span>
                                                            <p class="mt-2 text-sm text-gray-600">上传中...</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-1 mt-1">描述:</div>
                                    <textarea class="textarea textarea-bordered textarea-xs w-full max-w-xs h-48"
                                        placeholder="." v-model="FormData.description"></textarea>
                                    <button class="btn btn-neutral btn-sm btn-wide" @click="handleSave">保存</button>
                                    <div class="mt-4">封面推荐:</div>
                                    <div v-for="(item2, index) in uniqueTrackList" :key="index">
                                        <div class="flex justify-center items-center mt-1 mb-2">
                                            <div>
                                                <img :src="item2.image"
                                                class="mask mask-squircle w-16 h-16 cursor-pointer object-contain"
                                                @click="handleCopy('playlist_img', item2.image)">
                                            </div>
                                            <div class="flex-1 ml-2">
                                                <div class="cursor-pointer hover:underline"
                                                    @click="handleCopy('name', item2.artist)">{{ item2.artist }}</div>
                                                <div class="truncate w-56 text-gray-400 cursor-pointer hover:underline"
                                                    @click="handleCopy('description', item2.album)">{{ item2.album }}</div>
                                            </div>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-neutral btn-active btn-sm" onclick="playlist_delete.showModal()">
                            DELETE
                        </button>
                        <div class="dropdown ml-2" ref="selectContainer">
                            <div class="dropdown dropdown-end">
                                <div tabindex="0" role="button" class="btn btn-sm btn-active" @click="toggleDropdown">
                                    <!-- 下拉按钮图标 -->
                                    <svg t="1735448632254" class="icon h-6 w-6 fill-current" viewBox="0 0 1024 1024"
                                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5701" width="200"
                                        height="200">
                                        <path
                                            d="M227.14123 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C321.728492 456.087573 279.288914 413.647995 227.14123 413.647995z">
                                        </path>
                                        <path
                                            d="M510.903016 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C605.490278 456.087573 563.051723 413.647995 510.903016 413.647995z">
                                        </path>
                                        <path
                                            d="M794.665825 413.647995c-52.14973 0-94.587262 42.439578-94.587262 94.587262 0 52.14973 42.437531 94.587262 94.587262 94.587262 52.147684 0 94.587262-42.437531 94.587262-94.587262C889.253086 456.087573 846.813508 413.647995 794.665825 413.647995z"
                                            p-id="5704"></path>
                                    </svg>
                                </div>
                                <ul v-if="isDropdownOpen" tabindex="0" :class="['dropdown-content menu bg-base-100 rounded-box z-10 w-52 p-2 shadow !leading-3',
                                    dropdownDirection === 'up' ? 'bottom-full' : 'top-full']" @click.stop=""
                                    @blur="closeDropdown">
                                    <li v-if="isMiPlay">
                                        <a @click.stop="playInMi(playlist.id)">
                                            <svg-icon name="sys-xiaoai" class="w-4 h-4 fill-current" />
                                            小爱音箱播放
                                        </a>
                                    </li>
                                    <li>
                                        <a @click.stop="exportPlaylist(playlist.id)">
                                            <svg-icon name="export" class="w-4 h-4 fill-current" />
                                            导出播放列表
                                        </a>
                                    </li>
                                    <li>
                                        <a @click.stop="handleEditSmartPlaylist">
                                            <svg-icon name="edit" class="w-4 h-4 fill-current" />
                                            编辑智能歌单规则
                                        </a>
                                    </li>
                                    <li>
                                        <a @click.stop="updatePlaylistProps(playlist.id, 'exclude')">
                                            <svg-icon name="filter" class="w-4 h-4 fill-current" />
                                            标记为过滤列表
                                        </a>
                                    </li>
                                    <li>
                                        <a @click.stop="duplicatePlaylist(playlist.id)">
                                            <svg-icon name="player-repeat" class="w-4 h-4 fill-current" />
                                            列表去重复
                                        </a>
                                    </li>
                                    <li>
                                        <a @click.stop="handleShare">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-current" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                                <circle cx="18" cy="5" r="3"></circle>
                                                <circle cx="6" cy="12" r="3"></circle>
                                                <circle cx="18" cy="19" r="3"></circle>
                                                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                                                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                                            </svg>
                                            分享播放列表
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- 缩小状态的内容 -->
                <div v-else class="flex items-center justify-between w-full py-2 px-1">
                    <div class="flex flex-col">
                        <div class="text-lg font-medium truncate max-w-[200px]">{{ playlist.name }}</div>
                        <div class="text-sm text-gray-600 dark:text-gray-300 truncate max-w-[200px]">{{ playlist.tracks.length }}首歌曲 · {{ playlist.owner }}</div>
                    </div>
                    <div class="flex items-center space-x-2">
                        <button class="btn btn-neutral btn-xs" @click="playNow(playlist.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </Hero>
        </div>
        <div ref="trackContainer" class="flex-1 mt-2 overflow-y-auto rounded-xl" @scroll="handleScroll">
            <TrackList v-if="playlist.tracks.length > 0" :tracks="playlist.tracks" :index-field="'index'" :draggable="true">
            </TrackList>
        </div>
        <dialog id="playlist_delete" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">删除播放列表</h3>
                <p class="py-4">从音乐收藏中删除此播放列表，但不会删除源文件。</p>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="deletePlaylist">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="smart-playlist-edit" ref="smart-playlist-edit" class="modal">
            <div class="modal-box w-2/3 max-w-5xl max-h-[80vh] flex flex-col">
                <h3 class="text-lg font-bold sticky top-0 bg-base-100 z-10 pb-2">编辑智能播放列表规则</h3>
                <div class="py-4 flex-1 overflow-y-auto">
                    <div v-for="(item, index) in conditions" :key="'a' + index">
                        <div class="flex items-center">
                            <div v-if="index === 0">满足条件</div>
                            <div v-else>
                                <div class="btn btn-sm">或</div>
                                满足条件
                            </div>
                            <div class="ml-2 flex">
                                <button class="btn btn-square btn-outline btn-sm mr-1"
                                    @click="addItem">+</button>
                                <button class="btn btn-square btn-outline btn-sm"
                                    @click="removeItem(index)" v-if="conditions.length > 1">-</button>
                            </div>
                        </div>
                        <div class="flex mt-2 ml-6 items-center" v-for="(sub, subIndex) in item"
                            :key="'s' + index + 'a' + subIndex">
                            <div v-if="subIndex >= 1" class="mr-1 btn btn-sm">且</div>
                            <single-select
                                v-model="sub.key"
                                :options="keyOptions"
                                class="mr-1"
                            />
                            <single-select
                                v-if="boolKeyList.indexOf(sub.key) !== -1"
                                v-model="sub.operate"
                                :options="operateOptions"
                                class="mr-1"
                            />
                            <single-select
                                v-else-if="numberKeyList.indexOf(sub.key) !== -1"
                                v-model="sub.operate"
                                :options="operateGteOptions"
                                class="mr-1"
                            />
                            <single-select
                                v-else
                                v-model="sub.operate"
                                :options="valueOptions"
                                class="mr-1"
                            />
                            <select class="select select-bordered select-sm w-full max-w-xs"
                                v-if="boolKeyList.indexOf(sub.key) !== -1" v-model="sub.value">
                                <option value="">True</option>
                            </select>
                            <div class="w-full max-w-xs flex items-center"
                                v-else-if="numberKeyList.indexOf(sub.key) !== -1">
                                <input type="number" placeholder="请输入"
                                    class="input input-bordered input-sm w-full max-w-xs"
                                    v-model="sub.value" />
                                <div class="ml-2" v-if="sub.key === 'bit-rate'">kps</div>
                                <div class="ml-2" v-else-if="sub.key === 'size'">MB</div>
                                <div class="ml-2" v-else-if="sub.key === 'play-count'">次</div>
                                <div class="ml-2" v-else-if="sub.key === 'year'">年</div>
                                <div class="ml-2" v-else-if="sub.key === 'duration'">秒</div>
                                <div class="ml-2" v-else-if="sub.key === 'accessed-date'">天</div>
                                <div class="ml-2" v-else-if="sub.key === 'created-at'">天</div>
                                <div v-else></div>
                            </div>
                            <div class="w-full max-w-xs" v-else>
                                <input type="text" placeholder="请输入"
                                    class="input input-bordered input-sm w-full max-w-xs"
                                    v-model="sub.value" />
                            </div>
                            <div class="ml-2 flex">
                                <button class="btn btn-square btn-outline btn-sm mr-1"
                                    @click="addSubItem(index)">+</button>
                                <button class="btn btn-square btn-outline btn-sm"
                                    @click="removeSubItem(index, subIndex)"
                                    v-if="item.length > 1">-</button>
                            </div>
                        </div>
                        <div class="divider"
                            v-if="conditions.length > 1 && conditions.length !== index + 1">OR</div>
                    </div>
                    <div class="flex mt-4 items-center">
                        <div class="w-8 mr-1">最多</div>
                        <input type="text" placeholder="请输入"
                            class="input input-bordered input-sm w-16 max-w-xs mr-1" v-model="limit" />
                        <select class="select select-bordered select-sm w-16 max-w-xs mr-2"
                            v-model="unit">
                            <option value="item">项</option>
                        </select>
                        <div class="w-16 mr-1">选择标准</div>
                        <single-select
                            v-model="selectStandard"
                            :options="selectStandardOptions"
                        />
                    </div>
                    <div class="form-control w-24">
                        <label class="cursor-pointer label">
                            <input type="checkbox" class="checkbox checkbox-secondary"
                                v-model="isDynamic" />
                            <span class="label-text">动态更新</span>
                        </label>
                    </div>
                </div>
                <div class="modal-action sticky bottom-0 bg-base-100 z-10 pt-2">
                    <form method="dialog">
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleUpdateSmartPlaylist">保存</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <!-- 分享对话框 -->
        <PlaylistShareModal ref="shareModal" :playlist-id="id" />
    </ContentLoader>
</template>
<script>
import TrackList from '@/views/library/track/TrackList'
import Hero from '../../../components/library/Hero'
import ContentLoader from '@/components/library/ContentLoader'
import SingleSelect from '@/components/iview/SingleSelect'
import SvgIcon from '@/components/SvgIcon.vue'
import PlaylistShareModal from '@/components/library/PlaylistShareModal.vue'

const { getCoverArtUrl } = require('../../../api/apiUrl/subsonic/serializers')
export default {
    components: {
        TrackList, Hero, ContentLoader, SingleSelect, SvgIcon, PlaylistShareModal
    },
    props: {
    },
    data() {
        return {
            playlist: null,
            showEditModal: false,
            id: this.$route.params.id,
            uploadHeader: [
                { name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken') },
                { name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION') }
            ],
            uploadUrl: '/apimt/upload_image/',
            FormData: {},
            artistsData: [],
            uniqueTrackList: [],
            isMiPlay: localStorage.getItem('mi_play_in_pl') === '1' || false,
            isDropdownOpen: false,
            dropdownDirection: 'down',
            // 图片上传相关数据
            albumImagePreview: null,
            isUploadingAlbumImage: false,
            reloadImg: true,
            // 智能歌单编辑相关数据
            conditions: [[
                { 'key': 'favourite-track', 'operate': 'is', 'value': '' }
            ]],
            limit: 25,
            unit: 'item',
            selectStandard: '?',
            isDynamic: false,
            boolKeyList: ['favourite-track', 'favourite-album', 'favourite-artist', 'album-img', 'artist-img'],
            numberKeyList: ['play-count', 'sample-rate', 'bit-rate', 'size', 'year', 'duration', 'accessed-date', 'created-at', 'rating'],
            keyOptions: [
                { id: 'favourite-track', name: '标记为喜爱的歌曲' },
                { id: 'favourite-album', name: '标记为喜爱的专辑' },
                { id: 'favourite-artist', name: '标记为喜爱的艺术家' },
                { id: 'rating', name: '评分' },
                { id: 'file-path', name: '文件路径' },
                { id: 'title', name: '标题' },
                { id: 'album', name: '专辑' },
                { id: 'artist', name: '艺术家' },
                { id: 'genre', name: '流派' },
                { id: 'comment', name: '描述' },
                { id: 'lyrics', name: '歌词' },
                { id: 'language', name: '语言' },
                { id: 'album-img', name: '专辑图片' },
                { id: 'artist-img', name: '艺术家图片' },
                { id: 'play-count', name: '播放次数' },
                { id: 'bit-rate', name: '比特率' },
                { id: 'size', name: '大小' },
                { id: 'year', name: '年份' },
                { id: 'duration', name: '时长' },
                { id: 'accessed-date', name: '距离最近播放' },
                { id: 'created-at', name: '距离最近添加' },
            ],
            operateOptions: [
                { id: 'is', name: '是' },
                { id: 'not', name: '不是' },
            ],
            operateGteOptions: [
                { id: 'gte', name: '大于' },
                { id: 'lte', name: '小于' },
                { id: 'is', name: '是' },
                { id: 'not', name: '不是' },
            ],
            valueOptions: [
                { id: 'contain', name: '包含' },
                { id: 'not_contain', name: '不包含' },
                { id: 'startwith', name: '开头是' },
                { id: 'endwith', name: '结尾是' },
                { id: 'is', name: '是' },
                { id: 'not', name: '不是' },
            ],
            selectStandardOptions: [
                { id: '?', name: '随机' },
                { id: '-accessed_date', name: '最近播放' },
                { id: 'accessed_date', name: '最早播放' },
                { id: '-plays_count', name: '最常播放' },
                { id: 'plays_count', name: '最少播放' },
                { id: '-created_at', name: '最近添加' },
                { id: 'created_at', name: '最早添加' },
            ],
            // 滑动动画相关数据
            isHeroMinimized: false,
            scrollThreshold: 30, // 滑动阈值
            scrollHysteresis: 10, // 防抖区间（滞后值）
            isMobile: false,
            scrollAnimationFrame: null
        }
    },
    async created() {
        this.playlist = await this.$api.subsonic.getPlaylist(this.id)
        this.FormData = {
            name: this.playlist.name,
            description: this.playlist.comment,
            playlist_img: this.playlist.image ? this.playlist.image : ''
        }
        this.uniqueTrackList = this.playlist.tracks.reduce((unique, item) => {
            // 判断当前元素的 id 是否已经存在于 unique 列表中
            if (!unique.some(elem => elem.album === item.album)) {
                unique.push(item)
            }
            return unique
        }, [])
        // 初始化图片预览，使用工具方法格式化
        this.albumImagePreview = this.formatImageUrl(this.playlist.image)
    },
    mounted() {
        this.checkMobile()
        window.addEventListener('resize', this.checkMobile)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile)
        if (this.scrollAnimationFrame) {
            cancelAnimationFrame(this.scrollAnimationFrame)
        }
    },
    methods: {
        async playNow(id) {
            const playlist = await this.$api.subsonic.getPlaylist(id)
            return this.$store.dispatch('playTrackList', {
                tracks: playlist.tracks
            })
        },
        playInMi() {
            this.$api.Task.miServicePlayList({ 'pl_id': this.id }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '播放成功！',
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '播放失败！',
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        removeTrack(index) {
            this.playlist.tracks.splice(index, 1)
            return this.playlistStore.removeTrack(this.id, index)
        },
        updatePlaylist(value) {
            this.playlist = value
            return this.playlistStore.update(this.playlist)
        },
        deletePlaylist() {
            this.$api.subsonic.deletePlaylist(this.id).then((res) => {
                this.$myMsg.notify({
                    title: '删除成功！',
                    type: 'success',
                    time: 2000,
                })
                this.$router.push({ path: '/playlists/recently-added/' })
            })
        },
        handleEdit() {
            this.showEditModal = true
            this.genrePlaylistCoverFuc()
        },
        handleRes(response) {
            if (response.result) {
                this.FormData.playlist_img = response.data
                return true
            } else {
                return false
            }
        },
        handleCopy(k, v) {
            if (k === 'playlist_img') {
                this.FormData.playlist_img = v
                // 使用工具方法格式化图片URL
                this.albumImagePreview = this.formatImageUrl(v)
            } else {
                this.FormData[k] += ',' + v
            }
        },
        handleSave() {
            this.$api.Task.putPlayList({ id: this.id, ...this.FormData }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.$api.subsonic.getPlaylist(this.id).then((res) => {
                        this.playlist = res
                    })
                }
            })
        },
        genrePlaylistCoverFuc() {
            this.$api.Task.genrePlaylistCover({ 'id': this.id }).then((res) => {
                if (res.result) {
                    const img = getCoverArtUrl({ 'coverArt': res.data.coverArt })
                    if (this.uniqueTrackList && this.uniqueTrackList[0].coverArt === this.id) {
                        this.uniqueTrackList[0] = {
                            'image': img,
                            'artist': res.data.artist,
                            'album': res.data.album,
                            'coverArt': this.id
                        }
                    } else {
                        this.uniqueTrackList.unshift({
                            'image': img,
                            'artist': res.data.artist,
                            'album': res.data.album,
                            'coverArt': this.id
                        })
                    }
                }
            })
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        closeDropdown() {
            this.isDropdownOpen = false;
        },
        exportPlaylist(id) {
            this.$api.subsonic.exportPlaylist(id).then((res) => {
                window.open(res.url, '_blank')
                console.log(res)
            })
        },
        updatePlaylistProps(id, privacy_level) {
            this.$api.subsonic.updatePlaylistProps(id, privacy_level).then((res) => {
                this.$myMsg.notify({
                    title: '更新成功！',
                    type: 'success',
                    time: 2000,
                })
            })
        },
        duplicatePlaylist(id) {
            this.$api.subsonic.duplicatePlaylist(id).then((res) => {
                this.$myMsg.notify({
                    title: '去重成功！',
                    type: 'success',
                    time: 2000,
                })
                this.$api.subsonic.getPlaylist(id).then((res) => {
                    this.playlist = res
                })
            })
        },
        getPlaylistDetail(playlistId) {
            return this.$api.Task.playlistDetail({ playlist_id: playlistId }).then((res) => {
                if (res.result) {
                    return res.data
                } else {
                    this.$myMsg.notify({
                        title: '获取歌单详情失败',
                        content: res.message || '未知错误',
                        type: 'error',
                        time: 2000,
                    })
                    return null
                }
            }).catch((error) => {
                this.$myMsg.notify({
                    title: '获取歌单详情失败',
                    content: '网络错误',
                    type: 'error',
                    time: 2000,
                })
                console.error(error)
                return null
            })
        },
        updatePlaylistCondition(playlistId, conditionDict) {
            return this.$api.Task.updatePlaylist({ 
                playlist_id: playlistId, 
                condition_dict: conditionDict,
                is_dynamic: this.isDynamic
            }).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '更新歌单规则成功！',
                        type: 'success',
                        time: 2000,
                    })
                    return res.data
                } else {
                    this.$myMsg.notify({
                        title: '更新歌单规则失败',
                        content: res.message || '未知错误',
                        type: 'error',
                        time: 2000,
                    })
                    return null
                }
            }).catch((error) => {
                this.$myMsg.notify({
                    title: '更新歌单规则失败',
                    content: '网络错误',
                    type: 'error',
                    time: 2000,
                })
                console.error(error)
                return null
            })
        },
        // 移除专辑封面
        removeAlbumImage() {
            this.albumImagePreview = null
            this.FormData.playlist_img = ''
            if (this.$refs.albumImageInput) {
                this.$refs.albumImageInput.value = ''
            }
        },
        // 触发专辑封面替换
        triggerAlbumImageReplacement() {
            // 直接创建临时input，更可靠
            this.createTempFileInput('album')
        },
        
        // 创建临时文件输入
        createTempFileInput(type) {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'
            input.style.display = 'none'
            input.onchange = (event) => {
                if (type === 'album') {
                    this.handleAlbumImageChange(event)
                }
                // 清理临时元素
                if (input.parentNode) {
                    input.parentNode.removeChild(input)
                }
            }
            document.body.appendChild(input)
            input.click()
        },
        // 处理专辑封面图片选择
        handleAlbumImageChange(event) {
            const file = event.target.files[0]
            if (!file) return
            
            // 验证文件类型
            if (!file.type.startsWith('image/')) {
                this.$myMsg.notify({
                    title: '文件类型错误',
                    content: '请选择图片文件',
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 验证文件大小 (5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.$myMsg.notify({
                    title: '文件过大',
                    content: '图片大小不能超过5MB',
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 显示预览
            const reader = new FileReader()
            reader.onload = (e) => {
                this.albumImagePreview = e.target.result
            }
            reader.readAsDataURL(file)
            
            // 上传图片
            this.uploadImage(file, 'album')
        },
        // 通用图片上传方法
        uploadImage(file, type) {
            const formData = new FormData()
            formData.append('upload_file', file)
            
            // 设置上传状态
            if (type === 'album') {
                this.isUploadingAlbumImage = true
            }
            
            // 创建 XMLHttpRequest
            const xhr = new XMLHttpRequest()
            
            // 设置请求头
            xhr.open('POST', this.uploadUrl, true)
            xhr.setRequestHeader('X-CSRFToken', this.getCookie('django_vue_cli_csrftoken'))
            xhr.setRequestHeader('AUTHORIZATION', this.getCookie('AUTHORIZATION'))
            xhr.withCredentials = true
            
            // 处理响应
            xhr.onload = () => {
                // 重置上传状态
                if (type === 'album') {
                    this.isUploadingAlbumImage = false
                }
                
                if (xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText)
                        if (this.handleRes(response)) {
                            this.$myMsg.notify({
                                title: '上传成功',
                                type: 'success',
                                time: 2000,
                            })
                        } else {
                            this.$myMsg.notify({
                                title: '上传失败',
                                content: response.message || '未知错误',
                                type: 'error',
                                time: 2000,
                            })
                        }
                    } catch (e) {
                        console.log('解析响应出错:', e, '原始响应:', xhr.responseText)
                        this.$myMsg.notify({
                            title: '上传失败',
                            content: '服务器响应格式错误',
                            type: 'error',
                            time: 2000,
                        })
                    }
                } else {
                    this.$myMsg.notify({
                        title: '上传失败',
                        content: `HTTP错误: ${xhr.status}`,
                        type: 'error',
                        time: 2000,
                    })
                }
            }
            
            // 处理错误
            xhr.onerror = () => {
                if (type === 'album') {
                    this.isUploadingAlbumImage = false
                }
                this.$myMsg.notify({
                    title: '上传失败',
                    content: '网络错误',
                    type: 'error',
                    time: 2000,
                })
            }
            
            // 发送请求
            xhr.send(formData)
        },
        getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        // 格式化图片URL的工具方法
        formatImageUrl(imageData) {
            if (!imageData) return null;
            
            // 如果已经是data URL，直接返回
            if (imageData.startsWith('data:')) {
                return imageData;
            }
            
            // 如果是base64编码的图片数据（常见的开头）
            if (imageData.startsWith('/9j/') || imageData.startsWith('iVBOR') || imageData.startsWith('R0lGOD') || imageData.startsWith('UklGR')) {
                // 根据不同的开头判断图片类型
                let mimeType = 'image/jpeg'; // 默认
                if (imageData.startsWith('iVBOR')) {
                    mimeType = 'image/png';
                } else if (imageData.startsWith('R0lGOD')) {
                    mimeType = 'image/gif';
                } else if (imageData.startsWith('UklGR')) {
                    mimeType = 'image/webp';
                }
                return `data:${mimeType};base64,${imageData}`;
            }
            
            // 如果是普通URL，直接返回
            return imageData;
        },
        handleEditSmartPlaylist() {
            this.getPlaylistDetail(this.id).then((data) => {
                console.log(111, data)
                if (data && data.condition_dict) {
                    const conditionData = data.condition_dict
                    this.conditions = conditionData.conditions || [[
                        { 'key': 'favourite-track', 'operate': 'is', 'value': '' }
                    ]]
                    this.limit = conditionData.limit || 25
                    this.selectStandard = conditionData.order_by || '?'
                    this.isDynamic = data.is_dynamic
                } else {
                    this.conditions = [[
                        { 'key': 'favourite-track', 'operate': 'is', 'value': '' }
                    ]]
                    this.limit = 25
                    this.selectStandard = '?'
                }
                this.$refs["smart-playlist-edit"].showModal()
            })
        },
        addSubItem(index) {
            this.conditions[index].push({ 'key': '', 'operate': '', 'value': '' })
        },
        removeSubItem(index, subIndex) {
            if (this.conditions[index].length > 1) {
                this.conditions[index].splice(subIndex, 1)
            }
        },
        addItem() {
            this.conditions.push([{ 'key': '', 'operate': '', 'value': '' }])
        },
        removeItem(index) {
            this.conditions.splice(index, 1)
        },
        handleUpdateSmartPlaylist() {
            const conditionData = {
                conditions: this.conditions,
                limit: this.limit,
                order_by: this.selectStandard
            }
            this.updatePlaylistCondition(this.id, JSON.stringify(conditionData)).then((data) => {
                if (data !== null) {
                    this.$refs["smart-playlist-edit"].close()
                    this.$api.subsonic.getPlaylist(this.id).then((res) => {
                        this.playlist = res
                    })
                }
            })
        },
        // 处理滑动事件 (使用 requestAnimationFrame 优化性能，添加滞后防抖)
        handleScroll(event) {
            if (this.scrollAnimationFrame) {
                cancelAnimationFrame(this.scrollAnimationFrame)
            }

            this.scrollAnimationFrame = requestAnimationFrame(() => {
                const scrollTop = event.target.scrollTop
                let shouldMinimize = this.isHeroMinimized

                // 使用滞后逻辑防止在临界值附近闪烁
                // 向下滚动：超过阈值才缩小
                // 向上滚动：低于阈值-滞后值才恢复
                if (!this.isHeroMinimized && scrollTop > this.scrollThreshold) {
                    shouldMinimize = true
                } else if (this.isHeroMinimized && scrollTop < this.scrollThreshold - this.scrollHysteresis) {
                    shouldMinimize = false
                }

                if (this.isHeroMinimized !== shouldMinimize) {
                    this.isHeroMinimized = shouldMinimize
                }
            })
        },
        // 检查是否为移动端
        checkMobile() {
            this.isMobile = window.innerWidth < 768 // md断点
        },
        // 打开分享对话框
        handleShare() {
            this.$refs.shareModal.show()
        }
    }
}
</script>

<style scoped>
/* 移动端播放列表封面缩小动画 */
.hero-minimized {
    transform: none;
    height: auto !important;
    min-height: auto !important;
}

/* 缩小状态的特殊样式 */
@media (max-width: 767px) {
    .hero-minimized {
        margin-bottom: 0.5rem;
    }
}

@media (min-width: 768px) {
    .hero-minimized {
        transform: none;
    }
}
</style>
